// Ponte entre a Jornada e o tour guiado, do lado do Compliance.
//
// Espelho de `montarTourDoFeeFixo` (`@modules/fee-fixo/utils/
// iniciar-tour-guiado.js`): o TEXTO dos passos vem do catálogo (etapa crua do
// backend), os SELETORES de `constants/tour-compliance.js`, e o payload casado
// vai para a action `iniciarTour` do central-config. Registrado em `index.js`
// via `registrarTourDoModulo`, e é `startTaskNavigation` quem consulta o
// registry — então TODA superfície de "Iniciar etapa" (accordion da Jornada,
// barra embutida na Visão Geral, card da Home) guia sem chamar nada especial.
//
// Sem auto-start (ao contrário do Fee Fixo): o tour arranca só por "Iniciar
// etapa".
//
// ⚠️ DÍVIDA registrada no CLAUDE.md do módulo (§18): os helpers abaixo são
// cópia dos do Fee Fixo. Extraí-los para o central-config é refactor
// cross-módulo — fica para quando o terceiro módulo ganhar tour.
import {
  montarPassosDoTour,
  proximaEtapaGuiavel,
} from '@modules/central-config/utils/tour-steps'
import {
  moduloDoCatalogo,
  nivelDoModulo,
  moduloAteNivel,
  essentialTasksNaOrdemVisual,
} from '@modules/central-config/utils/progress'
import {
  PASSOS_DO_TOUR,
  MODULE_KEY_COMPLIANCE,
  temTourGuiado,
} from '@modules/compliance/constants/tour-compliance'

const STATUS_DONE = 'done'

const moduloDoStore = (store) => {
  const getters = (store && store.getters) || {}
  const modules = getters['centralConfig/journeyModules'] || []
  return moduloDoCatalogo(modules, MODULE_KEY_COMPLIANCE)
}

// A etapa crua (com metadata.instructions[]) — é dela que sai o texto.
const acharEtapaCrua = (modulo, taskId) => {
  const tasks = (modulo && modulo.tasks) || []
  return tasks.find((task) => task && task.id === taskId) || null
}

// Etapa cujo `premium_feature` o escritório não contratou é VITRINE: não pode
// ser oferecida como "próxima". `show` vazio (ainda carregando) não esconde.
const semAcessoPremium = (store, task) => {
  const metadata = (task && task.metadata) || {}
  const premium = metadata.premium_feature
  if (!premium) return false
  const show = (store && store.getters['parameters/show']) || {}
  if (!Object.keys(show).length) return false
  return !show[premium]
}

// Etapas do módulo na ordem visual, cortadas no nível atual — a mesma fatia
// que a barra embutida e o card da Home exibem.
const etapasDoModulo = (store, modulo) => {
  const ateNivel = moduloAteNivel(modulo, nivelDoModulo(modulo))
  return essentialTasksNaOrdemVisual(ateNivel).map((task) => {
    const metadata = (task && task.metadata) || {}
    return {
      id: task.id,
      slug: task.slug || '',
      name: task.name || '',
      url: task.url || '',
      isDone: metadata.status === STATUS_DONE,
      isIndisponivel: !!metadata.indisponivel || semAcessoPremium(store, task),
    }
  })
}

/**
 * Provedor de tour do Compliance — registrado em `index.js` e chamado por
 * `startTaskNavigation`. Devolve o payload de `iniciarTour`, ou null quando a
 * etapa não tem tour mapeado (aí a navegação segue com o drawer de texto).
 */
export function montarTourDoCompliance({ store, moduleId, task } = {}) {
  if (!store || !task || !temTourGuiado(task.slug)) return null

  const modulo = moduloDoStore(store)
  const crua = acharEtapaCrua(modulo, task.id)
  const passos = montarPassosDoTour({
    task: crua,
    mapa: PASSOS_DO_TOUR[task.slug],
  })
  if (!passos.length) return null

  const proxima = proximaEtapaGuiavel({
    etapas: etapasDoModulo(store, modulo),
    temTour: temTourGuiado,
    slugAtual: task.slug,
  })

  return {
    moduleId: moduleId || (modulo && modulo.id) || null,
    moduleKey: MODULE_KEY_COMPLIANCE,
    taskId: task.id,
    taskSlug: task.slug,
    passos,
    proximaEtapa: proxima
      ? { taskId: proxima.id, slug: proxima.slug, rotulo: proxima.name }
      : null,
  }
}
